import html2canvas from 'html2canvas'; // jsPDF eliminado, ya que no se usa

// Función auxiliar para descargar una imagen
const downloadImage = (dataUrl, filename) => {
    const link = document.createElement('a');
    link.href = dataUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
};

export const generarImagenes = async (html, nombreBase = 'Comprobante_Venta', numeroDocumento) => {
    // 1. Configurar contenedor temporal para la captura
    const tempContainer = document.createElement('div');
    tempContainer.style.position = 'absolute';
    tempContainer.style.left = '-9999px';
    tempContainer.style.width = '300px'; // Un ancho fijo para la captura
    tempContainer.innerHTML = html;
    document.body.appendChild(tempContainer);

    try {
        const nombreArchivo = `${nombreBase}_${numeroDocumento}`;

        // 2. Generar Canvas
        const canvas = await html2canvas(tempContainer, {
            scale: 2, // Mayor escala para mejor calidad de imagen
            useCORS: true
        });

        // 3. Generar y Descargar PNG
        //const pngData = canvas.toDataURL('image/png');
        //downloadImage(pngData, `${nombreArchivo}.png`);

        // 4. Generar y Descargar JPEG (se usa el mismo canvas)
        const jpegData = canvas.toDataURL('image/jpeg', 1.0);
        downloadImage(jpegData, `${nombreArchivo}.jpeg`);

    } catch (error) {
        console.error("Error al generar Imágenes:", error);
    } finally {
        // 5. Limpieza
        if (document.body.contains(tempContainer)) {
            document.body.removeChild(tempContainer);
        }
    }
};